import {Navbar} from "@common/ui/navigation/navbar/navbar";
import {Footer} from "@common/ui/footer/footer";
import React, {useState} from "react";
import {FormTextField} from "@ui/forms/input-field/text-field/text-field";
import {Trans} from "@ui/i18n/trans";
import {Button} from "@ui/buttons/button";
import {Form} from "@ui/forms/form";
import {UnsubscribePagePayload, useSubmitUnsubscribeForm} from "@app/instance/unsubscribe-page-form";
import {useForm} from "react-hook-form";
import {useRecaptcha} from "@common/recaptcha/use-recaptcha";

export function UnsubscribePage() {
    const form = useForm<UnsubscribePagePayload>();
    const [deactivationTime, setDeactivationTime] = useState<string | null>(null);
    const submitForm = useSubmitUnsubscribeForm(form, {
        onDeactivationTime: setDeactivationTime
    });
    const {verify, isVerifying} = useRecaptcha('unsubscribe');


    return (
        <div className="flex min-h-screen flex-col bg">
            <Navbar
                menuPosition="custom-page-navbar"
                className="sticky top-0 flex-shrink-0"
            />

                    <div className="container mx-auto flex flex-auto items-center justify-center p-24 md:p-40">
                        <div className="max-w-620 rounded border bg-paper p-24">
                            <h1 className="text-2xl">Unsubscribe</h1>
                            <p className="mb-30 mt-4 text-sm">Enter your phone number to unsubscribe.</p>
                            <Form
                                form={form}
                                onSubmit={async value => {
                                    const isValid = await verify();
                                    if (isValid) {
                                        submitForm.mutate(value);
                                    }
                                }}
                            >
                                <FormTextField
                                    label={<Trans message="Phone"/>}
                                    name="phone"
                                    required
                                    className="mb-20"
                                />
                                <Button
                                    type="submit"
                                    variant="flat"
                                    color="primary"
                                    disabled={submitForm.isPending || isVerifying}
                                >
                                    <Trans message="Unsubscribe"/>
                                </Button>
                                {deactivationTime && (
                                    <div className="mt-16 text-sm text-success">
                                        <Trans message="Your subscription deactivated on:"/> {deactivationTime}
                                    </div>
                                )}
                            </Form>
                        </div>
                    </div>



                    <Footer className="mx-14 md:mx-40"/>
                </div>
                );
                }